import { render } from "./ProjectDetailPage.vue?vue&type=template&id=4e996a7b&scoped=true"
import script from "./ProjectDetailPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailPage.vue?vue&type=script&lang=js"

import "./ProjectDetailPage.vue?vue&type=style&index=0&id=4e996a7b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e996a7b"]])

export default __exports__